module.exports = __webpack_public_path__ + "static/img/government-logo2x.4a322c4f.png";